<template>
    <client-page class="wrap wrap--mypage">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>

        <div class="contents">
            <div class="ct">
                <div class="mypage-container">
                    <!-- 네비게이션 메뉴 -->
                    <mypage-navigation></mypage-navigation>
                    <!-- 페이지 콘텐츠 -->
                    <div v-if="me" class="mypage-contents">
                        <div class="mypage-contents__head">
                            <h2 class="mypage-contents__title">회원정보수정</h2>
                        </div>
                        <div class="mypage-contents__body">
                            <div class="table-caption-right"><span class="color-red">*</span> 필수 입력항목</div>
                            <div role="table" class="myinfo-table myinfo-table--cell-background">
                                <div role="rowgroup">
                                    <myinfo-row label="아이디">
                                        {{ me.username }}
                                    </myinfo-row>
                                    <!-- 회원유형 -->
                                    <myinfo-usertype v-model="me" />

                                    <myinfo-row label="비밀번호" pointer>
                                        <v-text-field v-model="me.subPassword" type="password" name="" value="" outlined hide-details placeholder="비밀번호를 입력하세요." class="rounded-0" />
                                        <small class="d-block text-grey caption">(영문대소문자/숫자/특수문자 조합, 8 - 16자)</small>
                                    </myinfo-row>

                                    <myinfo-row label="비밀번호 확인" pointer>
                                        <v-text-field v-model="me.subPassword2" type="password" name="" value="" outlined hide-details placeholder="비밀번호를 재입력하세요." class="rounded-0" />
                                    </myinfo-row>

                                    <template v-if="isOrganization">
                                        <myinfo-row label="기업명" pointer>
                                            <v-text-field v-model="me.companyName" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="대표자명" pointer>
                                            <v-text-field v-model="me.ceoName" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="기업설립일" pointer>
                                            <v-text-field v-model="me.establishedAt" type="date" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="사업자등록번호" pointer>
                                            <v-text-field v-model="me.businessNumber" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                    </template>

                                    <myinfo-row v-if="isIndividual" label="이름" pointer>
                                        <v-text-field v-model="me.name" type="text" class="input rounded-0" outlined hide-details />
                                    </myinfo-row>
                                    <myinfo-row v-if="isSupporter" label="닉네임" pointer>
                                        <v-text-field v-model="me.nickname" type="text" class="input rounded-0" outlined hide-details />
                                    </myinfo-row>

                                    <myinfo-row v-if="isIndividual" :label="isSupporter ? '소속/부서' : '학교/학과'" pointer>
                                        <!-- <v-row>
                                            <v-col> -->
                                        <v-text-field v-model="me.affiliation" type="text" class="input rounded-0" outlined hide-details />
                                        <!-- </v-col>
                                            <v-col class="pl-0">
                                                <v-text-field v-model="me.department" type="text" class="input rounded-0" outlined hide-details />
                                            </v-col>
                                        </v-row> -->
                                    </myinfo-row>

                                    <myinfo-row label="연락처" pointer>
                                        <v-row align="center">
                                            <v-col class="py-0">
                                                <v-select v-model="me.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details class="rounded-0"></v-select>
                                            </v-col>
                                            -
                                            <v-col class="py-0">
                                                <v-text-field v-model="me.phone2" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                            </v-col>
                                            -
                                            <v-col class="py-0">
                                                <v-text-field v-model="me.phone3" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" class="rounded-0" />
                                            </v-col>
                                        </v-row>
                                    </myinfo-row>

                                    <myinfo-row label="이메일" pointer>
                                        <v-text-field v-model="me.email" type="text" class="input rounded-0" outlined hide-details />
                                    </myinfo-row>

                                    <myinfo-row v-if="!isSupporter" label="주소" pointer>
                                        <div class="form-address">
                                            <div class="form-address__postcode">
                                                <v-text-field
                                                    v-model="me.postcode"
                                                    type="text"
                                                    readonly
                                                    placeholder="우편번호"
                                                    outlined
                                                    hide-details
                                                    @click="$refs.daumPostcode.open()"
                                                    class="rounded-0"
                                                />
                                                <button class="button button--primary rounded-0" @click="$refs.daumPostcode.open()">검색</button>
                                            </div>
                                            <v-text-field
                                                v-model="me.address1"
                                                type="text"
                                                readonly
                                                placeholder="기본 주소를 입력해주세요."
                                                outlined
                                                hide-details
                                                @click="$refs.daumPostcode.open()"
                                                class="rounded-0"
                                            />
                                            <v-text-field v-model="me.address2" type="text" placeholder="상세 주소를 입력해주세요." outlined hide-details class="rounded-0" />
                                        </div>
                                    </myinfo-row>
                                    <!-- 자문분야 / 관심분야 -->
                                    <myinfo-areas v-model="me" :areas="areas" pointer />

                                    <template v-if="isOrganization">
                                        <myinfo-row label="홈페이지주소">
                                            <v-text-field v-model="me.website" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="담당자정보">
                                            <v-row>
                                                <v-col>
                                                    <v-text-field v-model="me.workerName" type="text" label="이름" placeholder=" " class="input rounded-0" outlined hide-details />
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="me.workerTitle" type="text" label="직책" placeholder=" " class="input rounded-0" outlined hide-details />
                                                </v-col>
                                            </v-row>
                                        </myinfo-row>
                                        <myinfo-row label="주요생산제품">
                                            <v-text-field v-model="me.mainProduct" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="기업개요">
                                            <v-textarea v-model="me.summary" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="기업로고">
                                            <v-file-input v-model="me.avatar" dense hide-details outlined class="rounded-0" accept="image/*" />
                                        </myinfo-row>
                                        <form-files title="소개자료" v-model="me.brochures" />
                                    </template>
                                    <template v-if="isSupporter">
                                        <myinfo-row label="전문가 소개">
                                            <v-textarea v-model="me.summary" type="text" class="input rounded-0" outlined hide-details />
                                        </myinfo-row>
                                        <myinfo-row label="전문가 사진">
                                            <v-file-input v-model="me.avatar" dense hide-details outlined class="rounded-0" accept="image/*" />
                                        </myinfo-row>
                                    </template>
                                    <template v-if="isExpert">
                                        <myinfo-row :label="isOrganization ? '전문기업' : '전문가'">
                                            <v-row>
                                                <v-col cols="auto" class="py-0">
                                                    <v-switch label="검색노출" v-model="me.isDisplayed" inset class="ma-0 ml-1" />
                                                </v-col>
                                                <v-col v-if="isSupporter" cols="auto" class="py-0 ml-3">
                                                    <v-switch label="연락처노출" v-model="me.isContactDisplayed" inset class="ma-0 ml-1" />
                                                </v-col>
                                            </v-row>
                                        </myinfo-row>
                                    </template>
                                </div>
                            </div>

                            <div class="bottom-button">
                                <button class="button button--border-primary"><span>취소</span></button>
                                <button class="button button--primary" @click="save"><span>저장</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <daum-postcode ref="daumPostcode" @change="({ postcode, address }) => Object.assign(me, { postcode, address1: address })"></daum-postcode>
    </client-page>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/data/CONSTANTS";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MyinfoRow from "@/components/client/mypage/myinfo-row.vue";
import FormFiles from "@/components/client/join/skin/form-files.vue";
import MyinfoAreas from "@/components/client/mypage/myinfo-areas.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import MyinfoUsertype from "@/components/client/mypage/myinfo-usertype.vue";

export default {
    components: {
        SubVisual,
        ClientPage,
        MyinfoRow,
        FormFiles,
        MyinfoAreas,
        DaumPostcode,
        MypageNavigation,
        MyinfoUsertype,
    },
    data() {
        return {
            me: null,
            areas: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                if (!this.accessToken) {
                    this.$router.push({
                        path: "/login",
                        params: this.$router.params,
                    });
                    return;
                }

                var { user } = await api.v1.me.get();
                var [phone1, phone2, phone3] = (user.phone || "").phoneNumberFormat().split("-");
                const avatar = user?.avatar?.url ? await api.getResource(user.avatar.url, true) : null;
                const brochures = await Promise.all((user?.brochures || [])?.map(async ({ url }) => api.getResource(url, true)));

                this.me = {
                    ...user,
                    phone1,
                    phone2,
                    phone3,
                    avatar,
                    brochures,
                    establishedAt: user.establishedAt?.toDate(),
                };

                var { areas } = await api.v1.areas.gets();
                this.areas = areas;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");
            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");
        },

        validate() {
            try {
                if ((this.me.subPassword || this.me.subPassword2) && this.me.subPassword != this.me.subPassword2) throw new Error("비밀번호 및 비밀번호확인이 일치하지 않습니다");
                if (this.me.subPassword && this.me.subPassword2) this.checkPassword(this.me.subPassword);

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                const _user = this.me._id;

                if (this.me?._avatar) {
                    await api.v1.users.avatar.delete({ _id: this.me._avatar, _user });
                }

                for (const _id of this.me?._brochures || []) {
                    await api.v1.users.brochures.delete({ _id, _user });
                }

                await api.v1.me.put({
                    ...this.me,
                    subPassword: this.me.subPassword ? CryptoAES.encrypt(this.me.subPassword) : undefined,
                    subPassword2: undefined,
                    _brochures: undefined,
                    brochures: undefined,
                });

                if (this.me?.avatar) {
                    await api.v1.users.avatar.post({ _user }, this.me.avatar);
                }

                if (this.me?.brochures?.length) {
                    for (const [index, brochure] of this.me.brochures.entries()) {
                        await api.v1.users.brochures.post({ _user, index }, brochure);
                    }
                }

                alert("수정되었습니다");
                this.$router.go();
            }
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        phone() {
            return this.phone1 && this.phone2 && this.phone3 ? [this.phone1, this.phone2, this.phone3].join("-") : undefined;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isIndividual() {
            return this.me.type == USER_TYPES.INDIVIDUAL;
        },
        isOrganization() {
            return this.me.type == USER_TYPES.ORGANIZATION;
        },
        isSupporter() {
            return this.me.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
        isExpert() {
            return this.me.isExpert;
        },
    },
    watch: {
        "me.phone1"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone2"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone3"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
    },
};
</script>
